module.exports = __webpack_public_path__ + "static/img/007.76cc9ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/007.png
// module id = gEC4
// module chunks = 1